import i18n from '../../../i18n';

export const SEV_META = {
  alert: {
    get label() {
      return i18n.t('metrics:sev.alert');
    },
    icon: 'bell',
    c: 'var(--st-alert)',
  },
  opportunity: {
    get label() {
      return i18n.t('metrics:sev.opportunity');
    },
    icon: 'bolt',
    c: 'var(--accent)',
  },
  info: {
    get label() {
      return i18n.t('metrics:sev.info');
    },
    icon: 'bolt',
    c: 'var(--petrol-ink)',
  },
};
